export function substituirCaracteres(valor, minimo, maximo) {
  if (typeof valor !== 'string' || valor === null) {
    return valor;
  }

  const totalCaracteres = valor.length;
  if (totalCaracteres > maximo) {
    return valor.substr(minimo, maximo);
  }
  return valor;
}



